"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MetaKeys;
(function (MetaKeys) {
    MetaKeys[MetaKeys["birchmountApiKey"] = 1] = "birchmountApiKey";
    MetaKeys[MetaKeys["birchmountLocationId"] = 2] = "birchmountLocationId";
    MetaKeys[MetaKeys["loyaltyPointsMultiplier"] = 3] = "loyaltyPointsMultiplier";
    MetaKeys[MetaKeys["hasVirtualLocation"] = 4] = "hasVirtualLocation";
    MetaKeys[MetaKeys["locationZoneOption"] = 5] = "locationZoneOption";
    MetaKeys[MetaKeys["pennyRounding"] = 6] = "pennyRounding";
})(MetaKeys = exports.MetaKeys || (exports.MetaKeys = {}));
var MetaDataType;
(function (MetaDataType) {
    MetaDataType["STRING"] = "string";
    MetaDataType["INTEGER"] = "integer";
    MetaDataType["DOUBLE"] = "double";
    MetaDataType["BOOLEAN"] = "boolean";
})(MetaDataType = exports.MetaDataType || (exports.MetaDataType = {}));
//# sourceMappingURL=MetaDataKey.js.map